// extracted by css-extract-rspack-plugin
var _1 = "ant-btn-icon-only-dG1dk6";
var _2 = "ant-btn-icon-only-dG1dk6";
var _3 = "column-tagged-Us4FZM";
var _4 = "column-tagged-Us4FZM";
var _5 = "common__breadcrumb-J9gb9K";
var _6 = "common__filter-HnReql";
var _7 = "common__form-ezA2d3";
var _8 = "common__form-buttons-SExnLU";
var _9 = "common__form-buttons-SExnLU";
var _a = "common__top-button-bar-tKMXgF";
var _b = "common__top-button-bar-tKMXgF";
var _c = "common_form--add-OEPdy2";
var _d = "common_form--change-password-NeFkyx";
var _e = "common_form--edit-a2N5S0";
var _f = "common_form--add-OEPdy2";
var _10 = "common_form--change-password-NeFkyx";
var _11 = "common_form--edit-a2N5S0";
var _12 = "details-kjcELI";
var _13 = "feedback-pIk08l";
var _14 = "form-buttons-EfGGOt";
var _15 = "form-horizontal-i2gpaD";
var _16 = "form-section-title-N_8IKx";
var _17 = "form-section-title-bigger-k5WkIF form-section-title-N_8IKx";
var _18 = "form-buttons-EfGGOt";
var _19 = "form-horizontal-i2gpaD";
var _1a = "form-section-title-N_8IKx";
var _1b = "form-section-title-bigger-k5WkIF form-section-title-N_8IKx";
var _1c = "formatted-json-xBO4lX";
var _1d = "formatted-json-xBO4lX";
var _1e = "heading-tag-rITBa2";
var _1f = "heading-tag-rITBa2";
var _20 = "list-tag-KcAvH5";
var _21 = "list-tag-KcAvH5";
var _22 = "table-actions-F3kWsd";
var _23 = "table-actions-F3kWsd";
var _24 = "top-button-bar-foAgUx";
var _25 = "top-button-bar-foAgUx";
export { _1 as "ant-btn-icon-only", _2 as "antBtnIconOnly", _3 as "column-tagged", _4 as "columnTagged", _5 as "common__breadcrumb", _6 as "common__filter", _7 as "common__form", _8 as "common__form-buttons", _9 as "common__formButtons", _a as "common__top-button-bar", _b as "common__topButtonBar", _c as "common_form--add", _d as "common_form--change-password", _e as "common_form--edit", _f as "common_formAdd", _10 as "common_formChangePassword", _11 as "common_formEdit", _12 as "details", _13 as "feedback", _14 as "form-buttons", _15 as "form-horizontal", _16 as "form-section-title", _17 as "form-section-title-bigger", _18 as "formButtons", _19 as "formHorizontal", _1a as "formSectionTitle", _1b as "formSectionTitleBigger", _1c as "formatted-json", _1d as "formattedJson", _1e as "heading-tag", _1f as "headingTag", _20 as "list-tag", _21 as "listTag", _22 as "table-actions", _23 as "tableActions", _24 as "top-button-bar", _25 as "topButtonBar" }
